import { Component, AfterViewInit, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/Rx';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
import { UserUrl } from "../../shared/urls/user.url";
import { __moduleName, CanDeactivateGuard } from "../../interfaces";
import { Utility } from "../../common/utility";
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';

import { AuthHelper } from '../../common/auth.helper';
import { SelectClinicService } from './select-clinic.service';
import { DialogService } from '../../shared/services/dialog.service';

@Component({
  selector: 'select-clinic',
  templateUrl: 'select-clinic-popup.component.html',
  providers: [SelectClinicService]
})

export class SelectClinicPopupComponent implements OnInit{
  public clinics: any;
  public title = "Add To Waiting Room";
  public clinicForm: FormGroup;
  public id = null;
  public data = { isSuccess: false, id: null};

  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private clinicService: SelectClinicService,
    public dialogService: DialogService,
    public dialogRef: MdDialogRef<SelectClinicPopupComponent>) {
      this.createForm();
  }

  ngOnInit() {
    this.initClinic();
  }

  createForm() {
    this.clinicForm = this.formBuilder.group({
      clinicId: [null, [Validators.required]]
    });
  }

  initClinic() {
    const centreId = localStorage.getItem('centreId');
    
    this.clinicService.getClinicList().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.clinics = data;
        }
      }
    );
  }

  onCloseDialog() {
    this.dialogRef.close(this.data);
  }

  onSubmitClinic() {
    //submit selected centre

    if (this.clinicForm.valid) {
      this.data.isSuccess = true;
      this.data.id = this.clinicForm.value.clinicId;
      this.onCloseDialog();
    }
    else
    {
      this.dialogService.openErrorDialog({ message: "Please select clinic before add the patient to waiting room." });
    }
  }

}








// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/select-clinic/select-clinic-popup.component.ts